var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"my-btn",attrs:{"size":_vm.elsize,"icon":_vm.elicon,"type":_vm.eltype},on:{"click":_vm.clickHandler}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.eltext))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }